import React, { useEffect, useRef, useState } from "react";
import blobTopLeft from "../Images/tealback.png";

const NumberedCards = ({ cardsData }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);

  const handleScroll = () => {
    const scrollTop = containerRef.current.scrollTop;
    const cardHeight = containerRef.current.clientHeight;
    const newActiveIndex = Math.round(scrollTop / cardHeight);

    setActiveIndex(newActiveIndex);
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [cardsData.length]);

  return (
    <div
      ref={containerRef}
      className="w-full lg:h-screen md:h-screen overflow-y-scroll scrollbar-hide pb-10"
      style={{
        backgroundImage: `url(${blobTopLeft})`,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      {cardsData.map((card, index) => (
        <div
          key={index}
          className="flex flex-col md:flex-row md:gap-5 lg:gap-5 w-full md:h-screen lg:h-screen lg:snap-start md:snap-start flex-shrink-0 px-10"
        >
          {/* Left teal div (Image) */}
          <div className="md:w-1/2 flex justify-center items-center my-10 md:my-20 rounded-lg">
            <div className="border-2 border-teal-300 my-10 md:my-20 rounded-lg p-5 bg-teal-300 bg-opacity-20">
              <img
                src={card.Icon}
                alt={card.title}
                className="w-full border-2 border-white  h-full md:w-[350px] md:h-[350px] lg:w-[500px] lg:h-[500px] object-cover rounded-lg"
              />
            </div>
          </div>

          {/* Right white div (Text) */}
          <div className="w-full md:w-1/2 flex flex-col justify-center md:items-start items-center md:mb-10 mb-10 relative">
            <div className="text-left">
              <h2 className="text-xl md:text-3xl lg:text-3xl font-bold text-white mb-6 md:mb-10">
                {card.title}
              </h2>
              <ul className="list-none">
                {card.description.map((point, idx) => (
                  <li key={idx} className="flex items-center text-white mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-circle-check-big text-white mr-2 w-6 h-6"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                      <path d="m9 11 3 3L22 4" />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Numbered list - Centered on the right */}
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 hidden md:block">
              {cardsData.map((_, numIndex) => (
                <div
                  key={numIndex}
                  className={`text-md mb-2 ${
                    activeIndex === numIndex
                      ? "text-teal-200 font-bold"
                      : "text-gray-200"
                  }`}
                >
                  0{numIndex + 1}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NumberedCards;
